import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-verification-success',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './verification-success.component.html'
})
export class VerificationSuccessComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthService);

  isVerifying = false;
  verificationFailed = false;
  errorMessage = '';

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const mode = params['mode'];
      const oobCode = params['oobCode'];

      // If the URL contains an oobCode, we handle the verification ourselves
      if (mode === 'verifyEmail' && oobCode) {
        this.isVerifying = true;
        this.authService.verifyEmailCode(oobCode)
          .then(() => {
            this.isVerifying = false;
            this.verificationFailed = false;
            // Clean up the URL
            this.router.navigate(['/verification-success']);
          })
          .catch(error => {
            console.error("Verification failed", error);
            this.isVerifying = false;
            this.verificationFailed = true;
            this.errorMessage = error.message;
          });
      }
    });
  }
}
